import * as home from './modules/home';
import * as image from './modules/image';
import * as video from './modules/video';

export default {
    home,
    image,
    video
}